<template>
  <div class="video_wrap">
    <vxe-modal
      v-model="show"
      @hide="hideModel"
      @show="showModel"
      :fullscreen="false"
      :id="'video'"
      width="600"
      height="400"
      min-width="600"
      min-height="400"
      show-zoom
      resize
      storage
      show-footer
      :transfer="true"
      :zIndex="1020"
      :destroy-on-close="true"
    >
      <template #title>
        <span>视频播放</span>
      </template>
      <template #default>
        <div v-if="show" class="video_player" id="mse"></div>
      </template>
      <template #footer>
        <vxe-button size="mini" @click="show=false">取消</vxe-button>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
import { fileType } from "@/util";
import Player from "xgplayer/dist/simple_player";
import volume from "xgplayer/dist/controls/volume";
import playbackRate from "xgplayer/dist/controls/playbackRate";
let Base64 = require("js-base64").Base64;
export default {
  props: {
    url: ""
  },
  computed: {
    d() {
      var arr = this.fileList.filter(e => e.status == "上传成功");
      return arr.map(e => e.name + "," + e.fileid).join("|");
    }
  },
  name: "CommonVideoPlayer",
  methods: {
    openVideo() {
      if (this.url) {
        this.show = true;
        this.$nextTick(()=>{
          let player = new Player({
            id: "mse",
            url: this.url,
            autoplay:true,
            height:'590',
            width:'320',
            controlPlugins: [ playbackRate],
          });
        })
      } else {
        this.$message.warning("请传入视频地址");
      }
    },
    hideModel() {},
    showModel() {}
  },
  data() {
    return {
      show: false
    };
  },
  created() {}
};
</script>

<style lang="scss">
.video_player {
    width: 100%;
    height: 100%;
    border: 1px solid #cccccc;
}
.xgplayer-skin-default .xgplayer-volume .xgplayer-icon{
    bottom:  14px !important;
}
.xgplayer-icon-pause svg{
    bottom: 0;
}
.xgplayer-icon{
    margin-top: -20px !important;
}
</style>
